import { useState } from 'react';
import { useModalControl } from '@frontend/design-system';

export type FilterExportWarning = {
  searchParams?: boolean;
  truncateDateRange?: boolean;
};

export const useInvoiceExportModalControl = () => {
  const { modalProps, openModal } = useModalControl();
  const [message, setMessage] = useState<FilterExportWarning>({});

  return {
    modalProps,
    exportWarning: message,
    showInvoiceExportWarning: (warningMessage: FilterExportWarning) => {
      setMessage(warningMessage);
      openModal();
    },
  };
};
